import { Factory } from 'rosie';

Factory.define('SearchQuery')
  .attr('filter', {});